import React from 'react'
import { ReactNode } from 'react'
import HomeActionCard from './HomeActionCard'

interface CardStudentLinkProps {
  title: string
  subtitle: string
  icon: ReactNode
  path?: string
}

/** Card de ação do aluno — delega para o card único da Home. */
export default function CardStudentLink({ title, subtitle, icon, path }: CardStudentLinkProps) {
  return <HomeActionCard icon={icon} title={title} description={subtitle} path={path} />
}
